import React, { useEffect, useState } from "react";
import UserDefaultAvatar from "assets/img/user.svg";
import { useHistory } from "react-router-dom";
import LazyLoadImage from "components/LazyLoadImage";
import ProgressBar from "components/Progressbar";

export default ({ recognitionStats, recognition }) => {
  const history = useHistory();
  const [peerRecognitionBar, setPeerRecognitionBar] = useState();

  useEffect(() => {
    setPeerRecognitionBar(calculateBar);

    //eslint-disable-next-line
  }, [recognition]);

  function calculateBar() {
    if (recognitionStats?.total_count === 0) {
      return 0;
    }

    return Math.floor(
      (recognition?.metrics?.created_celebration_count /
        recognitionStats?.total_count) *
        100
    );
  }

  const showUserProfile = (id) => {
    history.push(`/profile/${id}`);
  };

  return (
    <div className="recognitionStatRoot">
      <div className="recognitionAvatar">
        <LazyLoadImage
          style={{ cursor: "pointer" }}
          onClickFunction={() => showUserProfile(recognition?.id)}
          imageClassName="userAvatar"
          image={recognition?.avatar ?? UserDefaultAvatar}
          key={`${recognition?.full_name}`}
          alt={`${recognition?.full_name}`}
        />
        <span>{recognition?.full_name}</span>
      </div>
      <div className="row recognitionPerUserStat">
        <div className="col-6 col-md-6 col-lg-6 col-xl-6 leftSideRecognitionStat">
          <span className="activityPercentage">
            {peerRecognitionBar && `${peerRecognitionBar}%`} of Teams
            Recognitions
          </span>
          <ProgressBar
            completed={peerRecognitionBar}
            progressBackgroundColor={"#e0e0de"}
            height={"8px"}
            borderRadius={"10px"}
            bgcolor={"#1caca8"}
          />
        </div>
        <div className="col-6 col-md-6 col-lg-6 col-xl-6 rightSideRecognitionStat">
          <div>
            <span className="initiatedRecognition">Initiated Recognitions</span>
            <span className="initiatedRecognition recognitionNumber">
              {recognition?.metrics?.created_celebration_count}
            </span>
          </div>
          <div>
            <span className="engagedRecognition">Received Recognitions</span>
            <span className="engagedRecognition recognitionNumber">
              {recognition?.metrics?.got_celebrated_count}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
